import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CalculatorCard = ({ 
  title, 
  description, 
  icon, 
  path, 
  features,
  ctaText 
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
            {title}
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            {description}
          </p>
        </div>
      </div>
      <ul className="space-y-2 mb-6">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-2">
            <Icon 
              name="Check" 
              size={18} 
              color="var(--color-success)" 
              className="flex-shrink-0 mt-0.5"
            />
            <span className="text-sm text-foreground">{feature}</span>
          </li>
        ))}
      </ul>
      <Link
        to={path}
        className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium hover:bg-primary/90 transition-smooth active-press"
      >
        <span>{ctaText}</span>
        <Icon name="ArrowRight" size={18} color="currentColor" />
      </Link>
    </div>
  );
};

export default CalculatorCard;